import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export interface LzPDimmer {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    active?: boolean;
    onClick?: React.MouseEventHandler<HTMLElement>;
}

export default function LzXDimmer(props: LzPDimmer) {
    // Build styles based on input styles and some defaults
    const styles = props.style || {};
    if (typeof styles.zIndex === 'undefined') {
        styles.zIndex = 99999; // so that loading appers on top-most, i.e. even above Dialog
    }
    if (typeof styles.color === 'undefined') {
        styles.color = '#ffffff';
    }
    if (typeof styles.cursor === 'undefined' && props.onClick) {
        styles.cursor = 'pointer';
    }

    // Click handler if any
    const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };

    // Render the component
    return (
        <Backdrop open={!!props.active} className={'lz-dimmer ' + (props.className || '')} style={styles} onClick={handleOnClick}>
            <CircularProgress color="inherit" />
            {props.children}
        </Backdrop>
    );
}
